if (!customElements.get('curtain-pdp-shell')) {
  customElements.define('curtain-pdp-shell', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('[data-curtain-pdp-dialog]');
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-curtain-pdp-measure], [data-action="measure"]');
        if (trigger && (trigger.matches('[data-curtain-pdp-measure]') || this.contains(trigger))) {
          event.preventDefault();
          const mobileDrawer = trigger.closest('.ccn-drawer');
          this.returnTarget = mobileDrawer ? this.querySelector('[data-ccn-open]') : trigger;
          if (!this.dialog.open) this.dialog.showModal();
          this.dialog.querySelector('h2').focus({ preventScroll: true });
        }
        if (this.contains(event.target) && event.target.closest('[data-curtain-pdp-close]')) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        if (this.returnTarget?.isConnected) this.returnTarget.focus({ preventScroll: true });
        this.returnTarget = null;
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      const keepActiveThumbnailVisible = () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        const rail = document.querySelector('product-info.curtain-pdp .thumbnail-list');
        const active = rail?.querySelector('[aria-current="true"]')?.closest('.thumbnail-list__item');
        if (!rail || !active) return;
        const railRect = rail.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();
        if (activeRect.top < railRect.top) rail.scrollTop -= railRect.top - activeRect.top;
        else if (activeRect.bottom > railRect.bottom) rail.scrollTop += activeRect.bottom - railRect.bottom;
      };
      const media = document.querySelector('product-info.curtain-pdp media-gallery');
      if (media) {
        this.railObserver = new MutationObserver(keepActiveThumbnailVisible);
        this.railObserver.observe(media, { attributes: true, attributeFilter: ['aria-current'], childList: true, subtree: true });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.railObserver?.disconnect();
      this.controller = null;
    }
  });
}
